import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          为什么选择屁屁
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          五大核心优势，打造极致免费观影体验
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6 text-center transition-all hover:border-primary-200"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}